import React, { useContext, useEffect } from 'react';
import { useStaticQuery } from 'gatsby';
import useScript from 'react-script-hook';
import { Link } from '@interness/web-core/src/components/elements';
import { LanguageContext } from '@interness/web-core/src/providers';
import { jsx as ___EmotionJSX } from "@emotion/react";
const RolexClock = () => {
  const {
    directusProject
  } = useStaticQuery(query);
  let rolexClock = false;
  if (directusProject.config[0].brand_config[0]) {
    rolexClock = directusProject.config[0].brand_config[0].rolex_clock;
  }
  const {
    language
  } = useContext(LanguageContext);
  const [loading] = useScript({
    src: 'https://static.rolex.com/retailers/clock/retailercall.js',
    checkForExisting: true
  });
  useEffect(() => {
    if (rolexClock) {
      if (!loading) {
        let rdp;
        if (typeof window !== 'undefined') {
          rdp = new window.RolexRetailerClock();
        }
        const rdpConfig = {
          dealerAPIKey: directusProject.config[0].brand_config[0].rolex_api_key,
          lang: language,
          colour: 'gold'
        };
        try {
          if (typeof window !== 'undefined') {
            rdp.getRetailerClock(rdpConfig);
          }
        } catch (err) {
          console.log('Mounting Rolex Clock failed', err);
        }
      }
    }
  }, [directusProject.config, language, loading, rolexClock]);
  if (rolexClock) {
    return ___EmotionJSX(Link, {
      to: '/uhren/rolex',
      title: 'Rolex'
    }, ___EmotionJSX("div", {
      className: "rolex-retailer-clock"
    }));
  } else {
    return null;
  }
};
const query = "810214524";
export default RolexClock;